import { faFile } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { computed } from "mobx";
import { observer } from "mobx-react-lite";
import { default as React, useMemo, useCallback } from "react";
import { useDropzone } from "react-dropzone";
import {
  ComponentItemProps,
  TreeItem,
  TreeItemList,
} from "../components/ComponentTree";
import { IEditableComponent } from "../components/EditableComponent";
import { PageHomeRender, PageHomeSpec, PAGE_HOME } from "./PageHome";
import { verticalDI } from "../components/Vertical";
import { Vertical, VerticalItem } from "../components/VerticalEdit";
import { BarButton, SectionTitle } from "../components/PropertiesBar";
import { faImage } from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";

export const PageHomeRenderEdit = observer(
  verticalDI(PageHomeRender, Vertical)
);

const Properties = observer((props: { spec: PageHomeSpec }) => {
  return <div>Component has no properties</div>;
});

const ImagePreviewContainer = styled.div`
  max-width: 100%;
  margin-bottom: 10px;
`;

const ImagePreview = styled.img`
  width: 100%;
  border-radius: 4px;
`;

const DropzoneContainer = styled.div`
  border: 2px dashed #888;
  border-radius: 8px;
  background: #2a3035;
  padding: 20px;
  text-align: center;
  color: #ccc;
  margin-bottom: 10px;
  cursor: pointer;
`;

const SiteProperties = observer((props: { spec: PageHomeSpec }) => {
  const onDrop = useCallback(
    (acceptedFiles: File[]) => {
      acceptedFiles.forEach(async (f) => {
        const url = await (await fetch("/cms/upload")).text();
        // TODO: Placeholder, retry and status
        const res = await fetch(url, { method: "PUT", body: f });
        // TODO check res
        console.log(res);
        const downloadURL = url.split("?")[0];
        props.spec.headerImageURL = downloadURL;
      });
    },
    [props.spec]
  );

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: { "image/*": [] },
  });

  return (
    <div>
      <SectionTitle>Header Image</SectionTitle>
      {props.spec.headerImageURL ? (
        <>
          <ImagePreviewContainer>
            <ImagePreview
              src={props.spec.headerImageURL}
              alt="Header preview"
            />
          </ImagePreviewContainer>
          <BarButton
            onClick={() => (props.spec.headerImageURL = undefined)}
            style={{ backgroundColor: "red" }}
          >
            Reset to Default Image
          </BarButton>
        </>
      ) : (
        <DropzoneContainer {...getRootProps()}>
          <FontAwesomeIcon
            icon={faImage}
            size="2x"
            style={{ marginBottom: "10px" }}
          />
          <p style={{ margin: "5px 0" }}>Upload custom header image</p>
          <p style={{ margin: "5px 0", fontSize: "0.8em", opacity: 0.7 }}>
            (Default image is currently in use)
          </p>
          <input {...getInputProps()} />
        </DropzoneContainer>
      )}
    </div>
  );
});

const Item = observer((props: ComponentItemProps<PageHomeSpec>) => {
  const parentRefs = computed(() => [...props.parentRefs, props.spec]);
  return (
    <>
      <TreeItem onClick={props.onSelect} $isActive={props.selected}>
        <FontAwesomeIcon icon={faFile} />
        <span> Home Page </span>
      </TreeItem>
      <TreeItemList $paddingLeft={12}>
        <VerticalItem
          spec={props.spec.content}
          treeState={props.treeState}
          parentRefs={parentRefs.get()}
        />
      </TreeItemList>
    </>
  );
});

export const PageHome: IEditableComponent<PageHomeSpec> = {
  component: PageHomeRenderEdit,
  properties: Properties,
  siteProperties: SiteProperties,
  item: Item,
};
